module.exports = __webpack_public_path__ + "img/covid-19.9e6b5d99.png";